import { FilterConfig } from "../../../components/Tables/advancedRecord/FilterBar";

/**
 * Construye la configuración de filtros para la gestión de movimientos de inventario.
 */
export const buildInventoryMovementFilters = (
  branchDropdown: { id: number; name: string }[],
  productDropdown: { id: number; name: string }[]
): FilterConfig[] => [
  {
    name: "branchId",
    label: "Sucursal",
    type: "searchSelect",
    options: branchDropdown.map((b) => ({
      id: b.id,
      name: b.name,
    })),
    colSpan: 3,
  },

  {
    name: "productId",
    label: "Producto",
    type: "searchSelect",
    options: productDropdown.map((p) => ({
      id: p.id,
      name: p.name,
    })),
    colSpan: 4,
  },

  {
    name: "movementType",
    label: "Tipo de Movimiento",
    type: "select",
    options: [
      { id: "ENTRY", name: "Entrada" },
      { id: "EXIT", name: "Salida" },
      { id: "ADJUSTMENT", name: "Ajuste de Inventario" },
      { id: "INITIAL_INVENTORY", name: "Inventario Inicial" },
      { id: "TRANSFER_IN", name: "Entrada por Transferencia" },
      { id: "TRANSFER_OUT", name: "Salida por Transferencia" },
      { id: "DISCOUNT", name: "Descuento Aplicado" },
      { id: "PRICE_ADJUST", name: "Ajuste de Precio" },
    ],
    colSpan: 3,
  },

  {
    name: "startDate",
    label: "Fecha Inicio",
    type: "date",
    colSpan: 2,
  },

  {
    name: "endDate",
    label: "Fecha Fin",
    type: "date",
    colSpan: 2,
  },
];